import { useSession } from "./session";
import type { FeatureFlags } from "./session";

// Per-user feature flag check. Reads from the session's features map.
// In dev that comes from the stub; in Sprint 2+ it comes from the
// users.features jsonb column populated by Supabase auth.
export function useFeatureFlag(flag: keyof FeatureFlags): boolean {
  const session = useSession();
  return Boolean(session.features?.[flag]);
}
